import React, { useState } from 'react';
import ResetPasswordService from '../services/ResetPasswordService';
import { useData } from "../services/DataContext";
import Notification from "../components/Notifications/Notification";
import { useNavigate } from "react-router-dom";

const ConfigurationPage = () => {
  const navigate = useNavigate()
  const { userInfo } = useData();
  const [typeNotification, setTypeNotification] = useState(null);

  const handleSuccess = () => {
    setTypeNotification('success');
    setTimeout(() => {
      setTypeNotification(null);
      navigate('/login')
    }, 3000);
  }

  const handleError = () => {
    setTypeNotification('error');
    setTimeout(() => {
      setTypeNotification(null);
    }, 3000);
  }

  const handleAlert = () => {
    setTypeNotification('warning');
    setTimeout(() => {
      setTypeNotification(null);
    }, 3000);
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    if (confirmNewPasswordIsValid(e.target.newPassword.value, e.target.confirmNewPassword.value)) {
      const data = {
        oldPassword: e.target.oldPassword.value,
        newPassword: e.target.newPassword.value
      }
      try {
        await ResetPasswordService.changePassword(data);
        handleSuccess();
      } catch (error) {
        handleError();
      }
    }
  }

  const confirmNewPasswordIsValid = (newPassword, confirmNewPassword) => {
    if (newPassword !== confirmNewPassword) {
      handleAlert();
      return false;
    }
    return true;
  }

  if (!userInfo) {
    return (
      <div className="flex flex-column justify-center items-center h-screen text-5xl">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-row flex-1 w-full ">
        <div className="w-full">
          <div className="flex flex-col flex-wrap justify-center  2xl:px-60 h-full">
            <div className='bg-white shadow-lg h-full rounded-xl py-16'>
              <h1 className='font-medium text-2xl mb-4 text-center text-primary'>Configurações</h1>
              <hr className=''></hr>
              <form className='flex flex-col h-full justify-evenly px-6 md:px-40' onSubmit={onSubmit}>
                <div>
                  <label
                    className='text-gray-700'>Nome:</label>
                  <br />
                  <input className='w-full mb-4 p-2 rounded-md border border-gray-300 shadow-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500
                                    disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none
                                    invalid:text-pink-600
                                    focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                    type='text'
                    placeholder='Digite seu nome'
                    value={userInfo["fullName"]}
                    disabled />
                  <label
                    className='text-gray-700'>Email:</label>
                  <br />
                  <input className='w-full mb-4 p-2 rounded-md border border-gray-300 shadow-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500
                                    disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none
                                    invalid:border-pink-500 invalid:text-pink-600
                                    focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                    type='email'
                    placeholder='email@gmail.com'
                    value={userInfo["email"]}
                    disabled />
                  <label className='text-gray-700'>Senha atual:</label> <br />
                  <input className='w-full mb-4 p-2 rounded-md border border-gray-300 shadow-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500
                                    disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none
                                    invalid:text-pink-600
                                    focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                    type='password'
                    placeholder='Digite sua senha'
                    name='oldPassword' required />
                  <label className='text-gray-700'>Nova senha:</label> <br />
                  <input className='w-full mb-4 p-2 rounded-md border border-gray-300 shadow-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500
                                    disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none
                                    invalid:text-pink-600
                                    focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                    type='password'
                    placeholder='Digite sua nova senha'
                    name='newPassword' />
                  <label className='text-gray-700'>Confirme sua senha:</label> <br />
                  <input className='w-full mb-4 p-2 rounded-md border border-gray-300 shadow-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500
                                    disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none
                                    invalid:text-pink-600
                                    focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                    type='password'
                    placeholder='Confirme sua nova senha'
                    name='confirmNewPassword' />
                </div>
                <div className='flex justify-center'>
                  <input type='submit' className='bg-dark-primary text-white rounded-md p-2 w-52 shadow-lg duration-200 ease-in-out
                                    hover:bg-primary hover:text-white hover:shadow-none
                                    disabled:bg-slate-400 disabled:text-slate-100 disabled:border-slate-200 disabled:shadow-none cursor-pointer'
                    value={'Salvar'} />
                </div>
                {typeNotification === 'success' && <Notification title={'Sucesso'} message={'Senha alterada com sucesso'} type={typeNotification} />}
                {typeNotification === 'error' && <Notification title={'Erro'} message={'Erro ao alterar a senha, servidor indisponível'} type={typeNotification} />}
                {typeNotification === 'warning' && <Notification title={'Algo deu errado'} message={'Senhas não coincidem'} type={typeNotification} />}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfigurationPage;
